export default __webpack_public_path__ + "static/circle-9bb34cc1e9d54fd8d03f9142a083316d.png";